import React, {Component} from 'react'
import {observer} from 'mobx-react'

import Field from '../struct/Field'
import Hint from '../struct/Hint'
import InlineCode from 'lib/struct/InlineCode'

import Icon from 'lib/struct/icon/Icon';

import styles from './ProfileDocumentComponent.less'
import SettingsGroup from "../struct/SettingsGroup";
import Cookies from "js-cookie";

const {
    'block': block_class,
    'exported-xml-link__block': link_block_class,
    'exported-xml-link__block-item': link_block_item_class,
    'exported-xml-link__xml-link': xml_link_class,
    'exported-xml-link__download-link': download_link_class,
    'exported-xml-link__date-hint': date_hint_class,
    'exported-xml-link__link-hint': link_hint_class,
} = styles

@observer export default class ProfileDocument extends Component {
    render() {
        /** @type {ProfileSettingsContext} */
        const context = this.props.context
        const profile_document = context.profile_document
        const v2 = Cookies.get('force_set_wa_backend_ui_version') == 2

        if (!profile_document.document_exists) {
            return null
        }

        return (
            <div className={(v2 ? "fields " : '') + block_class}>
                <SettingsGroup>
                <Field label="YML-файл" wide>
                    <div className={link_block_class}>
						<span className={link_block_item_class}>
							<InlineCode className={xml_link_class}>{profile_document.document_page_url}</InlineCode>
						</span>
                        <span className={link_block_item_class}>
							<a
                                className={download_link_class}
                                href={profile_document.document_download_url}
                                target="_blank"
                            >
								<Icon name="download"/>Скачать
							</a>
						</span>
                    </div>

                    {
                        profile_document.updated_time ? (
                            <div className={date_hint_class}>Файл
                                обновлен: {profile_document.updated_humandatetime}</div>
                        ) : (null)
                    }

                    <Hint className={link_hint_class}>
                        <Icon name="yes"/> Ссылка на YML-файл постоянна для этого профиля и не изменяется при
                        повторном экспорте товаров.<br/>
                        Чтобы сделать ссылку недействительной, удалите профиль.
                    </Hint>
                </Field>
                </SettingsGroup>
            </div>
        )
    }
}
